import { HttpAgent } from '@icp-sdk/core/agent'
import { Principal } from '@icp-sdk/core/principal'
import { NftSendParams } from '../../interfaces/walletActions'
import { getExtTokenId } from './getExtTokenId'
import getNftActor from './getNftActor'

interface SendParams {
  agent: HttpAgent
  sendParams: NftSendParams
}

export const sendNft = async ({
  agent,
  sendParams: { standard, canisterId, receiverPrincipal, nftIndex },
}: SendParams) => {
  const actor = getNftActor(canisterId, standard, agent)

  const to = Principal.from(receiverPrincipal)
  const index = BigInt(nftIndex)
  const currentPrincipal = await agent.getPrincipal()

  if (actor.c3) {
    const response = await actor.c3.transferFrom(currentPrincipal, to, index)

    if ('err' in response) {
      throw Error(Object.keys(response.err)[0])
    }

    return true
  }

  if (actor.dip721) {
    const response = await actor.dip721.dip721_transfer(to, index)

    if ('Err' in response) {
      throw Error(`${Object.keys(response.Err)[0]}: ${Object.values(response.Err)[0]}`)
    }

    return true
  }

  if (actor.ext) {
    const token = getExtTokenId(canisterId, Number(index))
    const dummyMemmo = new Array(32).fill(0)

    const response = await actor.ext.transfer({
      to: { principal: to },
      from: { principal: currentPrincipal },
      token,
      amount: BigInt(1),
      memo: dummyMemmo,
      notify: false,
      subaccount: [],
      fee: BigInt(0),
    })

    if ('err' in response) {
      throw Error(`${Object.keys(response.err)[0]}: ${Object.values(response.err)[0]}`)
    }

    return true
  }

  if (actor.icpunks) {
    const success = await actor.icpunks.transfer_to(to, index)

    if (!success) throw Error('Error transferring icpunks NFT')

    return true
  }

  if (actor.icrc7) {
    const result = await actor.icrc7.icrc7_transfer([
      {
        to: {
          owner: currentPrincipal,
          subaccount: [],
        },
        token_id: index,
        memo: [],
        from_subaccount: [],
        created_at_time: [],
      },
    ])

    if ('Err' in result[0]) {
      //@ts-ignore
      throw Error(Object.keys(result[0].Err)[0])
    }
  }

  throw Error('Actor not found')
}
